export default {"src":"/_next/static/media/addAdditionalWatchIcon.cf2cc4b1.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};